// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-input-mark.disabled[data-v-4ff9476f]{pointer-events:none}input[data-v-4ff9476f]{border:1px solid hsla(0,0%,100%,0.1294117647)}`, "",{"version":3,"sources":["webpack://./client/components/Inputs/InputRadio.vue"],"names":[],"mappings":"AAIE,wCACE,mBAAA,CAIJ,uBACE,6CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
